/*
  "My Wishlist" in the header account menu.

  Wishlist Hero does not give this store a wishlist page — /pages/wishlist,
  /pages/my-wishlist, /apps/wishlist and /apps/wishlisthero all 404, and the
  app's own floating tab is an <a href="#"> that opens a modal from JS. So the
  menu item cannot be a plain link; it has to call the app.

  The app exposes window.WishListHero_SDK.OpenWishList(), which is what its own
  launcher uses. If a wishlist URL is ever set in Theme settings > Header >
  Account menu, header-account.liquid renders a normal link instead and this
  never runs.

  Delegated from document because the account menu renders twice per page —
  once in the desktop header, once in the mobile drawer.
*/
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-wishlist-open]');
    if (!trigger) return;

    event.preventDefault();

    // Close the account dropdown first, or it sits on top of the wishlist modal.
    var disclosure = trigger.closest('details');
    if (disclosure) disclosure.removeAttribute('open');

    var sdk = window.WishListHero_SDK;
    if (sdk && typeof sdk.OpenWishList === 'function') {
      sdk.OpenWishList();
      return;
    }

    // App still booting, or renamed its SDK: fall back to its own launcher.
    var launcher = document.querySelector('#wishlisthero-floating-launcher-container a');
    if (launcher) launcher.click();
  });
})();
